exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".upload-container[data-v-f03399f2]{display:flex;align-items:center;justify-content:center;padding:4px;border:2px dashed transparent;transition:all .3s ease;border-radius:4px;min-height:40px;min-width:80px}.drag-active[data-v-f03399f2]{border-color:#0b36dc;background-color:rgba(11,54,220,.05);transform:scale(1.1)}", ""]);

// exports
